import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';
import {
  CODE_ERRORS,
  ENDPOINT_API_PATH,
} from '../Definitions/ResetPasswordAccountIssueDef';

const autoGenerateSuccess = (type: string, value: string) => {
  const requestLogin =
    type === 'MEMBER'
      ? { memberNumber: value }
      : type === 'EMAIL'
      ? { email: value }
      : {
          document: {
            type,
            value,
          },
        };

  const resetPasswordAccountIssueSuccess: IMockProps = {
    doc: {
      code: 'Sucesso na solicitação de Reset de Senha',
      message: 'Sucesso na solicitação de Reset de Senha',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        ...requestLogin,
        formPage: {
          name: MocksDef.NAME,
          email: MocksDef.EMAIL,
          memberNumber: MocksDef.MEMBER_NUMBER,
          document: {
            type: 'CPF',
            value: MocksDef.DOCUMENT_TYPE.CPF,
          },
          phoneList: [
            {
              type: 'CELLULAR',
              internationalCode: MocksDef.PHONE_DDI,
              areaCode: MocksDef.PHONE_DDD,
              number: MocksDef.PHONE_NUMBER,
            },
          ],
        },
      },
    },
    configResponse: {
      status: 200,
      data: {
        serviceRequestId: '1-128182633147',
        message: 'Sucesso na solicitação de Reset de Senha',
      },
      headers: {},
    },
  };
  return resetPasswordAccountIssueSuccess;
};

const autoGenerateSuccessMember = autoGenerateSuccess(
  'MEMBER',
  MocksDef.MEMBER_NUMBER,
);
const autoGenerateSuccessEmail = autoGenerateSuccess('EMAIL', MocksDef.EMAIL);
const autoGenerateSuccessCPF = autoGenerateSuccess(
  'CPF',
  MocksDef.DOCUMENT_TYPE.CPF,
);
const generatedSuccessMocks = [
  autoGenerateSuccessMember,
  autoGenerateSuccessEmail,
  autoGenerateSuccessCPF,
];

const autoGenerate = (value: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body: {
            email: `${index}-${value}`,
            formPage: {
              name: MocksDef.NAME,
              email: MocksDef.EMAIL,
              memberNumber: MocksDef.MEMBER_NUMBER,
              document: {
                type: 'CPF',
                value: MocksDef.DOCUMENT_TYPE.CPF,
              },
              phoneList: [
                {
                  type: 'CELLULAR',
                  internationalCode: MocksDef.PHONE_DDI,
                  areaCode: MocksDef.PHONE_DDD,
                  number: MocksDef.PHONE_NUMBER,
                },
              ],
            },
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
            metadata: error.metadata,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const response = autoGenerate(MocksDef.EMAIL);
  return [...response];
};

const errorsGenerated = autoGenerateErrorsMock();

const ResetPasswordAccountIssueMocks = [
  ...generatedSuccessMocks,
  ...errorsGenerated,
];
export default ResetPasswordAccountIssueMocks;
